import React from 'react';
import PropTypes from 'prop-types';

const Apartment = ({ className, checked }) => (
    <svg
        width="56px"
        height="56px"
        viewBox="0 0 56 56"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className} ${
            checked
                ? 'path__stroke__checked polyline__stroke__checked'
                : 'path__stroke polyline__stroke'
        }`}
    >
        <title>Appartement</title>
        <g
            id="assets"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            opacity="0.6"
            strokeLinejoin="round"
        >
            <g id="Appartment" stroke="#393939" strokeWidth="2">
                <g id="Page-1" transform="translate(10.000000, 7.000000)">
                    <path
                        d="M4,41 L4,1 C4,0.448 4.448,0 5,0 L31,0 C31.553,0 32,0.448 32,1 L32,41 L21,41 L21,33 C21,32.447 20.553,32 20,32 L16,32 C15.448,32 15,32.447 15,33 L15,41 L4,41 Z"
                        id="Stroke-1"
                        strokeLinecap="round"
                    />
                    <path d="M11,12 L11,9" id="Stroke-3" strokeLinecap="square" />
                    <path d="M18,12 L18,9" id="Stroke-5" strokeLinecap="square" />
                    <path d="M25,12 L25,9" id="Stroke-7" strokeLinecap="square" />
                    <path d="M11,23 L11,20" id="Stroke-9" strokeLinecap="square" />
                    <path d="M18,23 L18,20" id="Stroke-11" strokeLinecap="square" />
                    <path d="M25,23 L25,20" id="Stroke-13" strokeLinecap="square" />
                    <path d="M0,41 L36,41" id="Stroke-15" strokeLinecap="round" />
                </g>
            </g>
        </g>
    </svg>
);

Apartment.displayName = 'Apartment';

Apartment.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
};

/**
 * Apartment Functional Component.
 */
export default Apartment;
